import {
  Injectable,
  Inject,
} from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LazyLoadService {
  private loadedLibraries: { [url: string]: ReplaySubject<boolean> } = {};

  constructor(
    @Inject(DOCUMENT) private readonly document: Document
  ) {
  }

  loadScript(url: string, atIdleTime?: boolean, delay?: boolean): Observable<boolean> {
    const doc = this.document;
    if (this.loadedLibraries[url]) {
      return this.loadedLibraries[url].asObservable();
    }

    this.loadedLibraries[url] = new ReplaySubject();


    const script = doc.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.setAttribute('defer','');

    script.addEventListener('load', () => this.onLoad(url));
    script.addEventListener('error', () => this.onError(url));

    if (atIdleTime && 'requestIdleCallback' in window) {
      window.requestIdleCallback(() => {
        doc.head.insertBefore(script, doc.head.firstChild);
      });
    } else if(delay) {
      doc.body.appendChild(script);
      // setTimeout(() => doc.head.insertBefore(script, doc.head.firstChild), delay);    
    } else {
      doc.head.insertBefore(script, doc.head.firstChild);
    }


    return this.loadedLibraries[url].asObservable();
  }

  loadStyle(url: string, atIdleTime?: boolean): Observable<any> {
    const doc = this.document;
    if (this.loadedLibraries[url]) {
      return this.loadedLibraries[url].asObservable();
    }

    this.loadedLibraries[url] = new ReplaySubject();

    const style = doc.createElement('link');
    style.type = 'text/css';
    style.href = url;
    style.rel = 'stylesheet';

    style.addEventListener('load', () => this.onLoad(url));
    style.addEventListener('error', () => this.onError(url));

    if (atIdleTime && 'requestIdleCallback' in window) {
      window.requestIdleCallback(() => {
        doc.head.appendChild(style);
      });
    } else {
      doc.head.appendChild(style);
    }

    return this.loadedLibraries[url].asObservable();
  }

  onLoad(url): void {
    const ll = this.loadedLibraries;
    ll[url].next(true);
    ll[url].complete();
  }

  onError(url): void {
    this.loadedLibraries[url].error(`error to load ${url}`);
  }

}
